import { Role } from '../types';
export const determineShouldShowSwitchLink = (userPermission) => {
    if (userPermission.isGlobal === true ||
        userPermission.role === Role.MANAGER ||
        userPermission.role === Role.ADMIN) {
        return true;
    }
    return false;
};
